<!--
 * @Description: 登录
 * @Autor: WangYuan
 * @Date: 2021-08-18 11:19:34
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-03-22 21:31:42
-->
<template>
  <div class="login">
    <div class="login-content">
      <div class="login-content-left">
        <!-- tabs -->
        <ul class="flex col-bottom mb60">
          <li
            v-for="tab in tabs"
            :key="tab.value"
            class="tab mr20"
            :class="[active == tab.value ? 'tab-active' : '']"
            @click="active = tab.value"
          >
            {{ tab.label }}
          </li>
        </ul>

        <!-- 登录 -->
        <template v-if="active == 'login'">
          <el-form :model="loginForm" ref="login" label-width="0">
            <el-form-item
              prop="account"
              class="mb40"
              :verify="{ minLen: 8, maxLen: 16, typeOptions: ['字母|数字'] }"
            >
              <el-input
                v-model="loginForm.account"
                placeholder="请输入账户名"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              class="mb70"
              :verify="{ passwordOptions: [6, 18, '字母|数字'] }"
            >
              <el-input
                v-model="loginForm.password"
                placeholder="输入密码登录"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>

          <el-button
            class="w-100 h48 f-white bg-theme r3 f18 lb-4"
            type="primary"
            @click="login"
            >登录</el-button
          >
          <!-- <div
            class="flex row-right mt25 f15 f-theme pointer"
            @click="active = 'register'"
          >
            免费注册
          </div> -->
        </template>

        <!-- 注册 -->
        <template v-if="active == 'register'">
          <el-form :model="registerForm" ref="register" label-width="0">
            <el-form-item
              prop="account"
              class="mb40"
              :verify="{ minLen: 8, maxLen: 16, typeOptions: ['字母|数字'] }"
            >
              <el-input
                v-model="registerForm.account"
                placeholder="请输入注册账户"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              class="mb40"
              :verify="{ passwordOptions: [6, 18, '字母|数字'] }"
            >
              <el-input
                v-model="registerForm.password"
                placeholder="请输入注册密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="userName" class="mb70" :verify="{ maxLen: 10 }">
              <el-input
                v-model="registerForm.userName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-button
            class="w-100 h48 f-white bg-theme r3 f18 lb-4"
            type="primary"
            @click="register"
            >注册</el-button
          >
        </template>
      </div>
      <div class="login-content-right">
        <img class="w-100" src='../assets/image/logo.png'/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login, register } from "@/api/user";
import { getProjectById } from "@/api/project";
import { getMyPermissions } from "@/api/role";
import request from "@/utils/request";

export default {
  name: "login",

  created() {
    this.logout();
  },

  data() {
    return {
      active: "login",
      loginForm: {
        account: '',
        password: ''
      },
      registerForm: {
        account: '', 
        password: '',
        userName: ''
      },
      tabs: [
        { label: "密码登录", value: "login" },
        // { label: "免费注册", value: "register" },
      ],
    };
  },

  watch: {
    active: {
      handler(newVal) {
        switch(newVal) {
          case 'login': 
            this.loginForm = {
              account: '',
              password: ''
            };
            break;
          case 'register':
            this.registerForm = {
              account: '', 
              password: '',
              userName: ''
            };
            break;
          default:
            break;
        }
      },
    },
  },

  methods: {
    ...mapMutations(["setToken", "setUserInfo", "logout", "setProject", "setCurPage", "setUserPermissions", "clearCurPage"]),

    // 登录
    async login() {
      this.$refs["login"].validate(async (valid) => {
        if (valid) {
          let res = await login(this.loginForm);

          if (res.status == "10000") {
            this.$notify({
              title: "登陆成功",
              message: "欢迎登陆E建云平台！",
              type: "success",
            });
            this.setToken(res.token);
            this.setUserInfo(res.userInfo);

            // 保存权限（子账号）
            if (res.userInfo && res.userInfo.permissions) {
              this.setUserPermissions(res.userInfo.permissions);
            }

            // 子账号登录：先加载项目数据，再设置授权的微站
            if (res.userInfo && res.userInfo.isSubAccount) {
              // 检查权限
              const permissions = res.userInfo.permissions || []
              if (permissions.length === 0) {
                // 无任何权限，直接跳转无权限页
                this.$router.push({ name: 'no-permission' })
                return
              }
              try {
                // 先加载项目数据（包含所有页面）
                let data = await getProjectById({ id: "66efd204cb155e2a185209f5" });
                let project = data.data;
                if (project) {
                  this.setProject(project);

                  // 设置授权微站列表（用于过滤可操作的站点）
                  const siteRes = await request({ url: '/site/list', method: 'GET' });
                  if (siteRes.status == "10000" && siteRes.data && siteRes.data.length > 0) {
                    // 获取第一个授权的微站
                    const firstSite = siteRes.data[0];
                    const firstSiteId = firstSite._id;

                    // 优先使用该微站的首页，没有则用第一个页面
                    const sitePages = project.pages?.filter(page => page.site === firstSiteId) || [];
                    const homePage = sitePages.find(page => page.home || page.site_home);
                    if (homePage) {
                      this.setCurPage(homePage);
                    } else if (sitePages.length > 0) {
                      this.setCurPage(sitePages[0]);
                    }
                    this.$router.push({ name: "mall" });
                  } else {
                    // 没有站点，清除 curPage，跳转到站点配置页面引导创建站点
                    this.clearCurPage();
                    this.$router.push({ path: '/mall/store' });
                  }
                } else {
                  this.$router.push({ name: "mall" });
                }
              } catch (error) {
                console.error('子账号登录流程出错:', error);
                // 出错时仍然跳转到 mall，让用户能进入系统
                this.$router.push({ name: "mall" });
              }
            } else {
              // 管理员登录：使用默认项目
              let data  = await getProjectById({ id: "66efd204cb155e2a185209f5" });
              let project = data.data
              this.setProject(project);
              this.$router.push({ name: "mall" });
            }

          } else {
            this.$notify({
              title: "登录失败",
              message: res.message,
              type: "warning",
            });
          }
        }
      });
    },

    // 注册
    register() {
      this.$refs["register"].validate(async (valid) => {
        if (valid) {
          let res = await register(this.registerForm);
          if (res.status == "10000") {
            this.$notify({
              title: "注册成功",
              message: "账户已注册成功，快去登录使用吧",
              type: "success",
            });
            this.active = "login";
            setTimeout(() => {
              this.$refs["login"].resetFields();
            }, 0);
          } else {
            this.$notify({
              title: "注册失败",
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: 0;
  border-radius: 0;
  padding: 0;
  font-size: 16px;
  border-bottom: solid 1px #dcdee0 !important;
}

::v-deep .el-input__icon {
  font-size: 20px;
}

.login {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #f2f3f5;
  overflow: hidden;

  .login-content {
    display: flex;
    height: 500px;
    margin-top: 200px;

    .login-content-left {
      width: 550px;
      margin-right: 20px;
      border-radius: 6px;
      background: #fff;
      padding: 50px 56px 60px;

      .tab {
        font-size: 20px;
        color: $color-grey;
        cursor: pointer;
      }

      .tab-active {
        font-size: 24px;
        color: #323233;
        font-weight: 500;
      }
    }

    .login-content-right {
      display: flex;
      align-items: center;
      width: 320px;
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>
